/**
 * Shared chrome in English: layout, header, footer, navigation and the 404
 * page. Translated from `locales/es/comun.ts`.
 */

export const comun = {
  saltarAlContenido: 'Skip to content',

  /** Home anchors. The `href` is the same in every language. */
  navLinks: [
    { href: '#flujo', label: 'Flow' },
    { href: '#soluciones', label: 'Solutions' },
    { href: '#planes', label: 'Plans' },
    { href: '#aliados', label: 'Partners' },
  ],

  header: {
    logoLabel: 'ILUMETRIA — home',
    navLabel: 'Main navigation',
    contacto: 'Contact',
    agendarDemo: 'Book a demo',
    inversionistas: 'Investors',
    plataforma: 'Platanometría',
    abrirMenu: 'Open menu',
    cerrarMenu: 'Close menu',
  },

  footer: {
    blurb:
      'Data intelligence for in-person events: matchmaking, passive lead capture and ROI attribution with IoT and AI.',
    instagramLabel: 'ILUMETRIA on Instagram',
    facebookLabel: 'ILUMETRIA on Facebook',
    correoLabel: (correo: string) => `Email ${correo}`,
    plataforma: {
      titulo: 'Platform',
      flujo: 'Value flow',
      soluciones: 'Solutions',
      planes: 'Plans',
      agendarDemo: 'Book a demo',
    inversionistas: 'Investors',
      demo: 'See the demo',
    },
    legal: {
      titulo: 'Legal',
      privacidad: 'Privacy Notice',
      terminos: 'Terms of Service',
      cookies: 'Cookie Policy',
      barbunnyPrivacidad: 'Bar Bunny Privacy',
      barbunnyEliminarCuenta: 'Delete Bar Bunny account',
    },
    derechos: (anio: number) => `© ${anio} ILUMETRIA. All rights reserved.`,
  },

  idioma: {
    selector: 'Language',
    cambiarA: (idioma: string) => `Switch language to ${idioma}`,
  },

  noEncontrada: {
    eyebrow: 'Error 404',
    titulo: 'This page does not exist',
    cuerpo: 'The link you followed is no longer available, or it was mistyped.',
    volver: 'Back to home',
  },

  acciones: {
    volverAlInicio: 'Back to home',
  },
};
